module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTQyMC42IDg2My43TDQxNiA4NjRsLTIuNC0wLjEtMy40LTAuNEEzMiAzMiAwIDAgMSAzODQgODMyVjE5MmEzMiAzMiAwIDAgMSA2NCAwdjU2My4xbDEyNi43LTEyNi43YTMyIDMyIDAgMSAxIDQ1LjIgNDUuMmwtMTgxIDE4MWEzMS45IDMxLjkgMCAwIDEtMTguMyA5LjF6IiBmaWxsPSIjMCIgcC1pZD0iMTAwNSI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Descending order-outlined.svg
// module id = maiS
// module chunks = 74